import React, { useState } from "react";
import { TextField, Button, Grid, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Form = ({
  formData,
  fetchData,
  handleClose,
  handleFetchSuccess,
  handleFetchFailure,
}) => {
  const navigate = useNavigate();

  // console.log(formData)
  const [data, setData] = useState({
    name: formData.name,
    desc: formData.desc,
    id: formData._id,
  });
  const [editMode, setEditMode] = useState(false);

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let token = userDetails ? userDetails.result.token : null;

    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_BASE_URL}/stokists/${data.id}`,
        {
          method: "PUT", // or 'POST' if applicable
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/login");
      }
      if (!response.ok) {
        handleFetchFailure();
        throw new Error("Network response was not ok");
      }
      // console.log('Form data submitted successfully');
      handleFetchSuccess();
      handleClose();
      setEditMode(false);
      fetchData();
    } catch (error) {
      console.error("Error submitting form data:", error);
      handleFetchFailure();
      handleClose();
    }
  };

  return (
    <Grid container justifyContent="center" className="">
      <Grid item>
        <Paper elevation={3} style={{ padding: "20px" }}>
          {editMode ? (
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                margin="normal"
                label="Stockist Name"
                id="name"
                name="name"
                value={data.name}
                onChange={handleChange}
                disabled
              />
              <TextField
                fullWidth
                margin="normal"
                label="Description"
                id="desc"
                name="desc"
                value={data.desc}
                onChange={handleChange}
                required
              />

              <Button
                variant="contained"
                sx={{
                  borderRadius: "20px",
                  backgroundColor: "var(--color-button)",
                  "&:hover": {
                    backgroundColor: "var(--color-button-hover)",
                  },
                }}
                type="submit"
              >
                Submit
              </Button>
              {/* <CustomizedSnackbars
                severity="success"
                message="API fetch successful!"
                open={fetchSuccess}
                handleClose={handlePopupClose}
              />
              <CustomizedSnackbars
                severity="error"
                message="API fetch failed!"
                open={fetchFailure}
                handleClose={handlePopupClose}
              /> */}
            </form>
          ) : (
            <div>
              <TextField
                fullWidth
                margin="normal"
                label="Stockist Name"
                value={data.name}
                InputProps={{ readOnly: true }}
              />
              <TextField
                fullWidth
                margin="normal"
                label="Description"
                value={data.desc}
                InputProps={{ readOnly: true }}
              />
              <div className="flex justify-between">
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: "20px",
                    backgroundColor: "var(--color-button)",
                    "&:hover": {
                      backgroundColor: "var(--color-button-hover)",
                    },
                  }}
                  onClick={handleEdit}
                >
                  Edit
                </Button>

                {/* <CustomizedSnackbars
                severity="success"
                message="API fetch successful!"
                open={fetchSuccess}
                handleClose={handlePopupClose}
              />
              <CustomizedSnackbars
                severity="error"
                message="API fetch failed!"
                open={fetchFailure}
                handleClose={handlePopupClose}
              /> */}
              </div>
            </div>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Form;
